var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadTrack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 101.44 100.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n.cls-1-tr,.cls-2-tr{fill:none;stroke-miterlimit:10;stroke-width:2px;}.cls-1-tr{stroke:#ff3b83;}.cls-2-tr{stroke:#ffc300;}\n"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-tr",
    x: 79.02,
    y: 52.84,
    width: 5.27,
    height: 24.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-tr",
    x: 89.32,
    y: 52.84,
    width: 5.27,
    height: 24.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-tr",
    x1: 9.49,
    y1: 77.01,
    x2: 9.49,
    y2: 99.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-tr",
    x1: 19.79,
    y1: 77.01,
    x2: 19.79,
    y2: 99.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-tr",
    x1: 30.1,
    y1: 77.01,
    x2: 30.1,
    y2: 99.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-tr",
    x1: 40.41,
    y1: 52.3,
    x2: 40.41,
    y2: 99.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-tr",
    x1: 50.72,
    y1: 78.21,
    x2: 50.72,
    y2: 99.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-tr",
    x1: 61.04,
    y1: 78.21,
    x2: 61.04,
    y2: 99.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-tr",
    x1: 71.34,
    y1: 52.3,
    x2: 71.34,
    y2: 99.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-tr",
    x1: 81.65,
    y1: 78.21,
    x2: 81.65,
    y2: 99.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-tr",
    x1: 91.96,
    y1: 78.21,
    x2: 91.96,
    y2: 99.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-tr",
    x: 6.85,
    y: 52.84,
    width: 5.27,
    height: 24.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-tr",
    x: 17.16,
    y: 52.84,
    width: 5.27,
    height: 24.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-tr",
    x: 27.47,
    y: 52.84,
    width: 5.27,
    height: 24.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-tr",
    x: 1.01,
    y: 52.84,
    width: 99.43,
    height: 46.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-tr",
    x: 48.09,
    y: 52.84,
    width: 5.27,
    height: 24.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-tr",
    x: 58.4,
    y: 52.84,
    width: 5.27,
    height: 24.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-tr",
    d: "M100.44,52.84v-11A12.57,12.57,0,0,0,87.87,29.26a11.56,11.56,0,0,0-1.19.06c0-.54.07-1.08.07-1.63a26.71,26.71,0,0,0-53.08-4.21,15.83,15.83,0,0,0-6.4-1.33,16.13,16.13,0,0,0-16,14.18,7.59,7.59,0,0,0-1.17-.09A9.07,9.07,0,0,0,1,45.31v7.54h99.44Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadTrack);
export default __webpack_public_path__ + "static/media/upload-track.b2e8c802aa4e8607cb7ac6e1d3065fe9.svg";
export { ForwardRef as ReactComponent };